import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteModel = createAsyncThunk(
  'listModels/fetchDeleteModel',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteModel(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteModelSlice = createSlice({
  name: 'models/delete',
  initialState,
  reducers: {
    resetDeleteModel: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteModel.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteModel.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteModel.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteModelSlice.reducer
export const { resetDeleteModel } = deleteModelSlice.actions
